import React from 'react'
import { AsideStyle, AsideStyleItem } from './style'

import Img1 from '../../assets/menu/aside1.svg'
import Img2 from '../../assets/menu/aside2.svg'
import Catalogo from '../../assets/catalogos/catalogo-junho-2021.pdf'

export default function MenuAside() {
  return (
    <AsideStyle>
      <AsideStyleItem className="AsideStyleItem--one">
        <a href="/#registro">
          <img src={Img1} />
        </a>
        <div className="AsideStyleItem--text">
					<a href="/#registro">
						QUIERO SER UN EMPRENDEDOR
					</a>
				</div>
      </AsideStyleItem>
      
      <AsideStyleItem className="AsideStyleItem--two">
        <a href={Catalogo} target="_blank" rel="noopener noreferrer">
					<img src={Img2} />
				</a>
        <div className="AsideStyleItem--text">
					<a href={Catalogo} className="anchor" target="_blank" rel="noopener noreferrer">
						VER CATÁLOGO
					</a>
				</div>
      </AsideStyleItem>
    </AsideStyle>
  )
}